import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import "../css/Ind-details.css";
import Navbar from "./Navbar";
import TitleBar from "./TitleBar";
import Footer from "./Footer";
import { fetchTransDetails } from "../Services/Api";

const PaymentDetails = (props) => {
  const { title, image } = props;
  const [filterText, setFilterText] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Define columns based on API response structure
  const columns = [
    {
      name: "S.No",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "80px"
    },
    {
      name: "Transaction ID",
      selector: (row) => row.transaction_id,
      sortable: true,
    },
    {
      name: "UTR Number",
      selector: (row) => row.utr_number,
      sortable: true,
    },
    {
      name: "Institution Name",
      selector: (row) => row.user_fullname,
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
    },
    {
      name: "No. of Licenses",
      selector: (row) => row.no_of_users,
      sortable: true,
    },
    {
      name: "Total Amount",
      selector: (row) => `₹${row.course_price.toLocaleString()}`,
      sortable: true,
    },
    {
      name: "Invoice Number",
      selector: (row) => row.invoice_no,
      sortable: true,
    },
    {
      name: "Date",
      selector: (row) => new Date(row.time_of_approval).toLocaleDateString(),
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
      cell: row => <div className={`status-badge ${row.status.toLowerCase()}`}>{row.status}</div>
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await fetchTransDetails();
        setData(response.data);
      } catch (err) {
        console.error("Error fetching transaction details:", err);
      } finally {
        setLoading(false);
      }
    };
    
    fetchData();
  }, []);

  const filteredData = data.filter(
    (item) =>
      item.user_fullname?.toLowerCase().includes(filterText.toLowerCase()) ||
      item.email?.toLowerCase().includes(filterText.toLowerCase()) ||
      item.transaction_id?.toLowerCase().includes(filterText.toLowerCase()) ||
      item.invoice_no?.toLowerCase().includes(filterText.toLowerCase())
  );

  const exportToExcel = () => {
    // Format data for export
    const exportData = filteredData.map(item => ({
      "Transaction ID": item.transaction_id,
      "UTR Number": item.utr_number,
      "Institution Name": item.user_fullname,
      "Email": item.email,
      "No. of Licenses": item.no_of_users,
      "Total Amount": item.course_price,
      "Invoice Number": item.invoice_no,
      "Date": new Date(item.time_of_approval).toLocaleDateString(),
      "Status": item.status
    }));
    
    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Transaction Details");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });
    saveAs(blob, "transaction_details.xlsx");
  };

  const exportToPDF = () => {
    const doc = new jsPDF();
    doc.text("Transaction Details", 14, 10);

    const tableColumn = ["Transaction ID", "Institution", "Email", "Amount", "Date", "Status"];
    const tableRows = filteredData.map((item) => [
      item.transaction_id,
      item.user_fullname,
      item.email,
      `₹${item.course_price.toLocaleString()}`,
      new Date(item.time_of_approval).toLocaleDateString(),
      item.status
    ]);

    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 20,
    });

    doc.save("transaction_details.pdf");
  };

  return (
    <>
      <Navbar />
      <TitleBar title={title} image={image} />
      <div className="user-table-container">
        <div className="user-table-header">
          <div className="user-table-controls">
            <div className="user-table-search">
              <input
                type="text"
                placeholder="Search by institution, email, transaction ID..."
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
                className="user-search-input"
              />
            </div>

            <div className="user-table-export">
              <button onClick={exportToExcel} className="export-btn export-excel">
                <span>Export to Excel</span>
              </button>
              <button onClick={exportToPDF} className="export-btn export-pdf">
                <span>Export to PDF</span>
              </button>
            </div>
          </div>
        </div>

        {loading ? (
          <div className="loading-indicator">Loading transaction data...</div>
        ) : (
          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            highlightOnHover
            striped
            customStyles={{
              head: {
                style: {
                  fontSize: '15px',
                },
              },
              headRow: {
                style: {
                  backgroundColor: '#ABBAF6',
                  borderTop: '1px solid #e0e0e0',
                  borderBottom: '1px solid #e0e0e0',
                },
              },
              headCells: {
                style: {
                  fontWeight: '600',
                  color: '#2c3e50',
                  paddingLeft: '12px',
                  paddingRight: '12px',
                },
              },
              cells: {
                style: {
                  paddingLeft: '12px',
                  paddingRight: '12px',
                },
              },
              rows: {
                style: {
                  fontSize: '14px',
                  '&:hover': {
                    backgroundColor: '#f8f9fa',
                  },
                },
                stripedStyle: {
                  backgroundColor: '#f8fafc',
                }
              },
              pagination: {
                style: {
                  borderTop: 'none',
                },
              },
            }}
          />
        )}
      </div>
      <Footer />
    </>
  );
};

export default PaymentDetails;